export const data = {
  experience: [
    {
      title: "Klasa skrzypiec",
      subTitle: "1949",
      description: "Podstawowa Krakowska Szkoła Muzyczna",
    },
    {
      title: "Kształcenie ogólne",
      subTitle: "1957–1964",
      description:
        "III Liceum Ogólnokształcące im. Jana Kochanowskiego w Krakowie",
    },
    {
      title: "Klasa trąbki",
      subTitle: "1959",
      description:
        "II Liceum im. Króla Jana III Sobieskiego, Państwowa Średnia Szkoła Muzyczna",
    },
    {
      title: "Klasa trąbki - dyplom",
      subTitle: "1964-1969",
      description: "Akademia Muzyczna w Krakowie - Wydział Instrumentalny",
    },
  ],
  education: [
    {
      title: "Kwintet Komedy",
      subTitle: "1963",
      description: "Współpraca z Krzysztofem Komedą",
    },
    {
      title: "Jazz Jamboree",
      subTitle: "1964",
      description:
        "Występy w Belgii i krajach skandynawaskich z Trzaskowskim i Komedą",
    },
    {
      title: "Jazz Jamboree",
      subTitle: "1967",
      description:
        "własny kwartet, w którym grał z Januszem Muniakiem (saksofon tenorowy), Janem Gonciarczykiem (kontrabas) i Januszem Stefańskim (perkusja",
    },
  ],
};
